import {
  BonusFreeSpinsMappedType,
  FREE_SPINS_STAGES,
  TriggerFreeSpinMappedType,
} from "types/Bonus";
import useTranslate from "hooks/useTranslate";
import "./styles.sass";
import classNames from "classnames";

type DescriptionFreeSpins = {
  bonus: BonusFreeSpinsMappedType | TriggerFreeSpinMappedType;
};

const DescriptionFreeSpins = ({ bonus }: DescriptionFreeSpins) => {
  const t = useTranslate();
  const { wager, freeSpinsCount, currency } = bonus;
  const sumFromToGettingReward =
    "minAmount" in bonus ? (bonus?.minAmount as number) / 100 : 0;
  const rewardAmount =
    "freeSpinsWinAmount" in bonus
      ? (bonus?.freeSpinsWinAmount * wager) / 100
      : 0;
  const reward =
    "wagerAmountRemain" in bonus
      ? (rewardAmount - bonus.wagerAmountRemain / 100).toFixed(2)
      : 0;
  const allFreeSpinsIsPlayed = rewardAmount === reward;
  const freeSpinsWinAmount =
    "freeSpinsWinAmount" in bonus ? bonus.freeSpinsWinAmount / 100 : 0;

  const fieldsFreeSpins = [
    {
      title: t("bonus.back.game"),
      value: "nameGameFreeSpin" in bonus ? bonus.nameGameFreeSpin : "",
    },
    bonus.freeSpinStage === FREE_SPINS_STAGES.AVAILABLE ||
    bonus.freeSpinStage === FREE_SPINS_STAGES.QUEUE ||
    bonus.freeSpinStage === FREE_SPINS_STAGES.UNUSED
      ? {
          title: t("bonus.back.spins"),
          value: `${freeSpinsCount} FS`,
        }
      : undefined,
    bonus.freeSpinStage === FREE_SPINS_STAGES.USED
      ? {
          title: t("bonus.card.back.sum.winning"),
          value: `${freeSpinsWinAmount} ${currency}`,
        }
      : undefined,
    {
      title: t("bonus.card.back.wagering.type"),
      value: t("bonus.card.back.wagering.type.real.balance"),
    },
    {
      title: t("bonus.information.wager"),
      value: `x${wager}`,
    },
    bonus.freeSpinStage === FREE_SPINS_STAGES.AVAILABLE
      ? {
          title: t("bonus.card.back.sum.getting.bonus"),
          value: `${t("bonus.card.back.from")} ${sumFromToGettingReward} ${currency}`,
        }
      : undefined,
    bonus.freeSpinStage === FREE_SPINS_STAGES.USED
      ? {
          title: t("bonus.title.played.progress"),
          value: (
            <span className="DescriptionFreeSpins__played">
              <span
                className={classNames(
                  allFreeSpinsIsPlayed
                    ? "DescriptionFreeSpins__played"
                    : "DescriptionFreeSpins__danger",
                )}
              >
                {reward}{" "}
              </span>
              / {rewardAmount} {currency}
            </span>
          ),
        }
      : undefined,
  ].filter((field) => field !== undefined);

  return (
    <div className="DescriptionFreeSpins">
      {fieldsFreeSpins.map((field) => (
        <div
          key={`${field?.title}DescriptionFreeSpins`}
          className="DescriptionFreeSpins__inner"
        >
          <div className="DescriptionFreeSpins__title">{field?.title}</div>
          <div className="DescriptionFreeSpins__value">{field?.value}</div>
        </div>
      ))}
    </div>
  );
};

export default DescriptionFreeSpins;
